<template>

<div class="directory-wrapper">

    <input class="directory-search" type="text" v-model="search" placeholder="Quick filter by name..." />

    <div class="directory">

        <app-user type="player" :not-linked="true" :item="item" v-for="(item, index) in dataFinal" :key="index" class="user" v-tooltip="'Click to view player profile'" v-on:click.native="onUserClick(item)">

            <core-card-foot-stat :value="item.plays" text="plays" />
            <core-card-foot-date :value="item.date" text="last play" />
            <core-card-foot-progress :value="item.ratio" text="win %" />

        </app-user>

    </div>

</div>

</template>

<script>

export default {

    data: function() {

        return {
            search: ''
        }

    },

    computed: {

        dataFinal: function() {

            var data = this.data
            
            if (this.search) {

                data = this.$_.filter(data, function(item) {

                    return item.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0

                }.bind(this))

            }

            return this.$_.sortBy(data, 'name')

        },

		data: function() {

			return this.$store.getters['page/insights/players/directory']

		}

	},

    methods: {

        onUserClick: function(item) {

            this.$router.push({
				name: 'InsightsPlayer', 
				params: {
					player: item.slug
				}
			})

        }

    }

}

</script>

<style scoped>

.directory {
    display: grid;
    grid-gap: 20px;
    grid-template-columns: 1fr 1fr;
}

.is-mobile .directory {
    grid-template-columns: 1fr;
}

.directory-search {
    border: 1px solid #ddd;
    height: 40px;
    border-radius: 4px;
    margin-bottom: 20px;
    width: 100%;
    padding: 0px 10px;
}

.user {
    border: 1px solid #ddd;
    border-radius: 4px;
    height: 70px!important;
    background-color: #fff!important;
    padding: 10px!important;
    display: grid!important;
    grid-template-columns: 48px 1fr 80px 80px 80px;
    cursor: pointer;
}

.is-desktop .user:hover {
    border-color: #4881bb;
}

.user >>> .card-foot-item {
    padding: 0px;
}

.user-avatar {
    width: 48px;
	min-width: 48px;
	height: 48px;
	border-radius: 24px;
	font-size: 24px;
}

.user-name {
	overflow: hidden;
	min-width: 0;
	display: block;
	max-width: 100%;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-size: 16px;
	line-height: 16px;
	cursor: pointer;
	overflow: hidden;
	color: #333;
	font-weight: 500;
}

@media only screen and (max-width: 767px) {

	.user-name :hover { 
		font-size: 14px;
	}

}

.user-name-username {
	font-size: 12px;
	font-weigt: 400;
	color: #666;
	line-height: 12px;
	margin-top: 2px;
}

</style>